import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid, Button } from "@mui/material/";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import Fade from "react-reveal/Fade";
import { db, doc, addDoc, collection, deleteDoc } from "../../firebase";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import ConfirmDialog from "../ConfirmDialog";
import HelpIcon from "@mui/icons-material/Help";
import LeftMenu from "./LeftMenu";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { useForm } from "react-hook-form";

const useStyles = makeStyles({
  body: {
    backgroundColor: "white",
    minHeight: "500px",
    padding: "50px",
    fontSize: "17px",
  },
  title: { fontSize: "30px" },
});

const Dashboard = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { getAddresses, currentUser } = useAuth();
  const [allAddresses, setAllAddresses] = useState([]);

  const [error, setError] = useState("");

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (removeId) => {
    setRemoveAddressId(removeId);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setAllAddresses(getAddresses());
  }, [getAddresses]);

  // const resetAddress = () => {
  //   setFn("");
  //   setLn("");
  //   setAddress("");
  //   setApt("");
  //   setCity("");
  //   setState("");
  //   setZipcode("");
  //   setAddressId(null);
  // };

  const [removeAddressId, setRemoveAddressId] = useState(null);

  const removeAddress = async () => {
    try {
      await deleteDoc(
        doc(db, "users", currentUser.uid, "address", removeAddressId)
      );
    } catch (error) {
      setError(
        "There is a technical issue. We are very sorry about inconvenience. Try later."
      );
      console.log(error);
    }
  };

  const submit = async (data) => {
    if (add.length > 4) {
      try {
        const docRef2 = await addDoc(
          collection(db, "users", currentUser.uid, "address"),
          {
            firstname: data.firstname,
            lastname: data.lastname,
            address: show_address,
            apt: data.address_from_user,
            city: show_city,
            state: show_state,
            zipcode: show_zipcode,
          }
        );
        console.log("Document written 2 with ID: ", docRef2.id);
      } catch (error) {
        console.log(error);
      }
    } else {
      setError("주소 검색으로 주소를 입력해주십시오");
      setTimeout(() => {
        setError("");
      }, 3000);
    }
  };

  const { daum } = window;

  const [add, setAdd] = useState("");
  const [show_address, setShow_address] = useState(null);
  const [show_state, setShow_state] = useState(null);
  const [show_zipcode, setShow_Zipcode] = useState(null);
  const [show_city, setShow_city] = useState(null);

  const createNew = () => {
    new daum.Postcode({
      oncomplete: function (data) {
        console.log(data);
        if (data.buildingName) {
          setAdd(
            data.address + " (" + data.buildingName + ")" + " " + data.zonecode
          );
          setShow_address(data.address + " (" + data.buildingName + ")");
          setShow_Zipcode(data.zonecode);
          setShow_state(data.sido);
          setShow_city(data.sigungu);
        } else {
          setAdd(data.query + " " + data.sido + " " + data.zonecode);
          setShow_address(data.query);
          setShow_Zipcode(data.zonecode);
          setShow_state(data.sido);
          setShow_city(data.sigungu);
        }
      },
    }).open();
  };

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ px: 4, py: 4 }}>
          <Box sx={{ fontWeight: 800, pb: 2 }}>주소 삭제</Box>
          <DialogContentText id="alert-dialog-description">
            이 주소를 삭제 하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>취소</Button>
          <Button onClick={removeAddress}>삭제하기</Button>
        </DialogActions>
      </Dialog>
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="address" />
      <Grid md={9} sm={12} className={classes.body}>
        <Fade delay={300}>
          <Box sx={{ fontWeight: 600, fontSize: "17px" }}>
            <Fade delay={300}>{t("Manage your address")}</Fade>
          </Box>

          <Box sx={{ pt: 3 }}>
            <div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "14px",
                }}
              >
                <Box sx={{ mt: 1 }}>
                  {allAddresses?.map((add) => {
                    console.log("add", add);
                    return (
                      <Box
                        style={{
                          width: "100%",
                          height: "50px",
                          display: "flex",
                          cursor: "pointer",
                        }}
                      >
                        <Box
                          sx={{
                            pr: 2,
                            textDecoration: "underline",
                            fontSize: "14px",
                          }}
                          className="pink_link"
                          onClick={() => handleClickOpen(add.id)}
                        >
                          {t("Delete")}
                        </Box>
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          &nbsp;{add.lastname && add.lastname}
                        </span>{" "}
                        <span
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            paddingLeft: "3px",
                          }}
                        >
                          {add.firstname && add.firstname}
                        </span>
                        &nbsp;&nbsp;&nbsp;{add.address && add.address}
                        &nbsp;&nbsp;{add.apt && add.apt}
                        {/* &nbsp;&nbsp;
                       
                        {add.city && add.city}&nbsp;
                        {add.state && add.state}&nbsp;
                        {add.state && add.zipcode} */}
                      </Box>
                    );
                  })}
                </Box>
                <Box sx={{ borderTop: "1px solid lightgray", pt: 5 }}>
                  <button
                    className="custom_btn"
                    // onClick={addNewAddress}
                    onClick={createNew}
                    style={{ width: "240px" }}
                  >
                    주소 검색으로 새 주소 입력하기
                    {/* {t("Add Address")} */}
                  </button>
                  <form
                    onSubmit={handleSubmit((data) => {
                      submit(data);
                    })}
                  >
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 3 }}>
                      <TextField
                        variant="filled"
                        label="성*"
                        sx={{ width: "200px" }}
                        {...register("lastname", {
                          required: "Last name is required.",
                        })}
                      />
                      <TextField
                        label="이름*"
                        variant="filled"
                        sx={{ width: "200px", ml: 2 }}
                        {...register("firstname", {
                          required: "First name is required.",
                        })}
                      />
                    </Box>
                    <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                      <TextField
                        label="주소*"
                        variant="filled"
                        value={add}
                        onChange={(e) => setAdd(e.target.value)}
                        sx={{ width: "418px", pointerEvents: "none" }}
                      />
                      <Tooltip title="주소 검색으로 입력하실수 있습니다">
                        <HelpIcon sx={{ ml: 1, color: "gray" }} />
                      </Tooltip>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                      <TextField
                        label="나머지 주소"
                        variant="filled"
                        sx={{ width: "418px" }}
                        {...register("address_from_user", {})}
                      />
                    </Box>
                    <Box>
                      {errors.firstname && (
                        <Alert
                          severity="warning"
                          sx={{ width: "386px", mt: 1 }}
                        >
                          {t(errors.firstname?.message)}
                        </Alert>
                      )}
                      {errors.lastname && (
                        <Alert
                          severity="warning"
                          sx={{ width: "386px", mt: 1 }}
                        >
                          {t(errors.lastname?.message)}
                        </Alert>
                      )}
                      {errors.address_from_daum && (
                        <Alert
                          severity="warning"
                          sx={{ width: "386px", mt: 1 }}
                        >
                          {t(errors.address_from_daum?.message)}
                        </Alert>
                      )}
                      {error && (
                        <Alert
                          severity="warning"
                          sx={{ width: "386px", mt: 1 }}
                        >
                          {t(error)}
                        </Alert>
                      )}
                    </Box>
                    <button
                      type="submit"
                      className="custom_btn"
                      style={{ width: "240px", marginTop: "20px" }}
                    >
                      {t("Submit")}
                    </button>
                  </form>
                </Box>
              </Box>
            </div>
          </Box>
        </Fade>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
